/** @format */

import { IconButton, Popover, Stack, SvgIcon, Tooltip, Typography } from '@mui/material';
import VolumeOnIcon from '@untitled-ui/icons-react/build/esm/VolumeMax';
import VolumeOffIcon from '@untitled-ui/icons-react/build/esm/VolumeX';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectClientActiveInteract, setClientActiveInteract } from 'src/store/app-slice';
import RequestNew from './booking-notice-request/request-new';
import RequestAwaitingApproval from './booking-notice-request/request-waiting-approval';
import RequestTab from './booking-notice-tab';
import { selectBookingNoticepPopoverTab, setTabBookingRequestPopover } from './booking-notice.slice';
import { tabs } from './ultis';

export const BookingNoticePopover = (props) => {
  const { anchorEl, requests, onClose, open = false, ...other } = props;
  const dispatch = useDispatch();
  const isActiveInteract = useSelector(selectClientActiveInteract);
  const tab = useSelector(selectBookingNoticepPopoverTab);

  const handleTabsChange = useCallback((_event, value) => {
    dispatch(setTabBookingRequestPopover(value));
  }, []);

  const handleActiveInteract = useCallback((value) => {
    dispatch(setClientActiveInteract(value));
  }, []);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'top'
      }}
      disableScrollLock
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            minWidth: 380,
            mt: 1
          }
        }
      }}
      {...other}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={2}
        sx={{
          px: 3,
          pt: 2
        }}
      >
        <Typography color="inherit" variant="h6">
          Kết nối kèo
        </Typography>
        <Tooltip title="Mark all as read">
          <IconButton
            onClick={() => {
              handleActiveInteract(!isActiveInteract);
            }}
            size="small"
            color="inherit"
          >
            <SvgIcon>{isActiveInteract ? <VolumeOnIcon /> : <VolumeOffIcon />}</SvgIcon>
          </IconButton>
        </Tooltip>
      </Stack>
      <RequestTab handleTabsChange={handleTabsChange} tab={tab} />
      {tab === tabs.requestNew.value && <RequestNew requests={requests.dataNew} />}
      {tab === tabs.reConfirm.value && <RequestAwaitingApproval requests={requests.dataAccepted} />}
    </Popover>
  );
};
